import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@components/common/Tooltip';
import { parsePrice } from '@utils/price-helpers';
import { addItemToCart, deleteItemFromCart } from '@utils/shopify-helpers';
import { deleteItemByKey, addItem, setIsLoading } from '@features/cart/cartSlice';
import { useDispatch, useSelector } from 'react-redux';
import styles from './CartPairCare.module.scss';

const CartPairCare = ({ bundleKey, addInfo, insuredBaseFrame, hasPairCare, pairCareKey }) => {
	const dispatch = useDispatch();
	const [itemKey, setItemKey] = useState(pairCareKey);
	const product = useSelector(state => state.cart.pairCareProduct);

	const addPairCareAndUpdateCart = async ({ variantId, quantity, bundleKey, frame }) => {
		dispatch(setIsLoading({ value: true, key: bundleKey }));
		if (hasPairCare) {
			await deleteItemFromCart(itemKey, 0);
			dispatch(deleteItemByKey({ itemKey }));
			setItemKey(pairCareKey);
		} else {
			const response = await addItemToCart({ variantId, quantity, bundleKey, frame, product });
			if (response.status === UNPROCESSABLE_ENTITY) {
				return;
			}
			const addedItem = response.items[0];
			dispatch(addItem({ newItem: addedItem }));
			setItemKey(addedItem.key);
		}
	};

	return product ? (
		<div
			data-select-paircare=''
			{...(hasPairCare ? { [`data-itemkey`]: itemKey } : {})}
			className={`cursor-pointer col-12 cart-item cart-item__paircare upsell item-${product.id} upsell-${bundleKey} ${
				hasPairCare ? 'active' : ''
			}`}
			style={{ alignItems: 'start' }}
			data-product={JSON.stringify(product)}
			onClick={() => {
				addPairCareAndUpdateCart({
					variantId: product.id,
					quantity: 1,
					bundleKey,
					frame: insuredBaseFrame,
				});
			}}
		>
			<div className='checkbox-select flex-shrink-0 my-2' />
			<div className='h-x100 align-items-center d-flex flex-grow-1 justify-content-start w-100'>
				<div
					className={`align-self-center pl-3 text-lg-left text-center cart-item__title w-100 ${styles.protectFramesContainer}`}
				>
					<div className={styles.protectFrameLabel}>
						<p className='m-0 title cart-title-flex text-left'>
							<span className='blue-text title'>Pair</span>
							<span className='pink-text title'>Care</span>
						</p>
						<div className={`d-flex justify-content-start ${styles.gap}`}>
							<Tooltip message='PairCare only covers the cost of the base frame. Any lens add-ons will need to be repurchased with the replacement Pair' />
							<div className='d-flex flex-grow-0 align-items-center pl-1'>
								<div
									className={`caption item-price flex-fill align-self-center cart-item__quant item-price-${product.id}`}
								>
									${parsePrice(product.price, 0)}
								</div>
							</div>
						</div>
					</div>
					<div className='p text-left'>{addInfo}</div>
				</div>
			</div>
			<div className='d-flex flex-grow-0 align-items-center delete-control'>
				<svg className='mx-2' width='1' height='16' viewBox='0 0 1 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<line x1='0.5' y1='2.18557e-08' x2='0.499999' y2='16' stroke='#9B9A9A' />
				</svg>
				<div className={`button item-price flex-fill align-self-center cart-item__quant item-price-${product.id}`}>
					${parsePrice(product.price, 0)}
				</div>
			</div>
		</div>
	) : null;
};

CartPairCare.propTypes = {
	bundleKey: PropTypes.string,
	addInfo: PropTypes.string,
	pairCareKey: PropTypes.string,
	hasPairCare: PropTypes.bool,
};

export default CartPairCare;
